module.exports = "pegasus/assets/preview-3.png";